import { render, staticRenderFns } from "./i-xinvoice.vue?vue&type=template&id=59358a28&"
import script from "./i-xinvoice.vue?vue&type=script&lang=js&"
export * from "./i-xinvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports